var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"m-subtle",class:[
    {
      hover: _vm.hover,
      disabled: _vm.disabled,
      active: _vm.active,
      rotate: _vm.rotate,
    },
    _vm.type,
  ],attrs:{"disabled":_vm.disabled},on:{"click":(e) => !_vm.disabled && _vm.$emit('click', e),"mouseover":(e) => !_vm.disabled && _vm.$emit('mouseover', e),"mouseleave":(e) => !_vm.disabled && _vm.$emit('mouseleave', e),"mouseenter":(e) => !_vm.disabled && _vm.$emit('mouseenter', e),"mouseout":(e) => !_vm.disabled && _vm.$emit('mouseout', e),"mousedown":(e) => !_vm.disabled && _vm.$emit('mousedown', e),"mouseup":(e) => !_vm.disabled && _vm.$emit('mouseup', e)}},[(!!_vm.icon || !!_vm.$slots.icon)?_vm._t("icon",function(){return [_c('m-icon',{attrs:{"icon":_vm.icon}})]}):_vm._e(),(!!_vm.$slots.default || !!_vm.label)?_c('span',{staticClass:"m-subtle__text"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2):_vm._e(),_vm._t("icon-right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }